import {Directive, ElementRef, Output, EventEmitter, Input} from '@angular/core';

@Directive({
  selector: '[appInputFinished]'
})
export class InputFinishedDirective {
  @Output() appInputFinished = new EventEmitter<any>();
  @Input() delayMs = 1000;

  private timeoutInstanceId: string;

  constructor(private elRef: ElementRef) {
    this.elRef.nativeElement.addEventListener('input', () => {
      this.timeoutInstanceId = (Math.random() * 10000).toString();
      const timeoutInstanceLocal = this.timeoutInstanceId;
      setTimeout(() => {
        if (timeoutInstanceLocal === this.timeoutInstanceId) {
          this.appInputFinished.emit(this.elRef.nativeElement.value);
        }
      }, this.delayMs);
    });
  }
}
